import React from 'react';
import {
	INSPECTION_STATES,
	SEARCH_INSPECTIONS_INPUTS
} from '../../../../constants/app/inspection'
import Select from '../../../shared/form/select'
import Input from '../../../shared/form/input'


const InspectionsHeader = ({ states, searchFilter, searchValue, handleFilter  = () => {}, handleChange  = () => {}, filterSelected = '', presencial }) => {
	return (
	<div className="pt10 pb20">
		<div className="row">
		<div className="col-xs-6 col-sm-3">
				<Select
					options={[{ id: '', label: 'Todas' }, ...INSPECTION_STATES]}
					value={(presencial === 2) ? '' : states}
					label="ESTADO DE INSPECCIÓN"
					id="states"
					labelClass="text-white"
					onChange={handleChange}
				/>
			</div>
			<div className="col-xs-6 col-sm-3">
				<Select
					options={[{ id: 'NONE', label: 'Todas' }, ...SEARCH_INSPECTIONS_INPUTS]}
					value={searchFilter}
					label="BUSCAR INSPECCIÓN"
					id="searchFilter"
					onChange={handleChange}
					labelClass="text-white"
				/>
			</div>
			<div className="col-xs-6 col-sm-6">
				<div class="ui-input-group search-button">
					<input className="ui-form-control" value={searchValue} id="searchValue" placeholder="Buscar" onChange={handleChange} disabled={(filterSelected === '' || filterSelected === 'NONE')}/>
					<span className="ui-input-group-addon-button">
						<button class="btn" type="button"
						onClick={handleFilter}
						>
						<img src='./images/search.svg' className="search-icon"/>
						</button>
					</span>
				</div>
			</div>
		</div>
	</div>
)
};
export default InspectionsHeader;


// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspections/inspections-header.js